(function ($) {

    $(document).ready(function () {
        bindButtons();
    });

    function bindButtons() {
        $(document).on('click', '[data-bookable_type]', function (e) {
            var button = $(this);
            var cfg = button.data();
            if(cfg.bookable_type === 'form' || cfg.bookable_type === 'thirdparty'){
                $.fancybox.open({
                    src  : cfg.expand_id,
                    type : 'inline',
                    opts : {
                        touch: false,
                        afterShow : function( instance, current ) {
                            console.log('instance >>>', instance);
                            console.log('current >>>', current.$smallBtn[0]);
                            if(cfg.bookable_type === 'form'){
                                var dateFormat = 'dd/mm/yy';
                                if($('form').hasClass('deform_spa') || $('form').hasClass('deform_meeting') || $('form').hasClass('deform_restaurant')){
                                    var event_date_datepicker = $('.form_wrap .fieldname_date'),
                                        event_date_input = $('.form_wrap .fieldname_date .hasDatepicker');

                                    if(event_date_datepicker.length > 0){
                                        var event_today = new Date();

                                        event_date_input.val($.datepicker.formatDate(dateFormat, event_today));

                                        event_date_datepicker.datepicker({
                                            dateFormat: dateFormat,
                                            firstDay: ($('html').attr('dir') === 'rtl') ? 0 : 1,
                                            minDate : event_today,
                                            isRTL: $('html').attr('dir') === 'rtl',
                                            onSelect: function(dateText, inst){
                                                event_date_datepicker.find('.ui-datepicker-inline').css('display', 'none');
                                                event_date_input.val(dateText);
                                            }
                                        });

                                        event_date_datepicker.find('.ui-datepicker-inline').css('display', 'none');

                                        event_date_input.on('click', function (){
                                            event_date_datepicker.find('.ui-datepicker-inline').css('display', 'block');
                                        });
                                    }

                                }

                                // Offer form
                                if($('form').hasClass('deform_offer')){
                                    var arrival_datepicker = $('.form_wrap .fieldname_arrival_date'),
                                        arrival_input = $('.form_wrap .fieldname_arrival_date .hasDatepicker'),
                                        departure_datepicker = $('.form_wrap .fieldname_departure_date'),
                                        departure_input = $('.form_wrap .fieldname_departure_date .hasDatepicker');

                                    if(arrival_datepicker.length > 0 || departure_datepicker.length > 0){
                                        var today = new Date(),
                                            tomorrow =  new Date(today.getTime() + 86400000);

                                        arrival_input.val($.datepicker.formatDate(dateFormat, today));
                                        departure_input.val($.datepicker.formatDate(dateFormat, tomorrow));

                                        arrival_datepicker.datepicker({
                                            dateFormat: dateFormat,
                                            firstDay: ($('html').attr('dir') === 'rtl') ? 0 : 1,
                                            minDate : today,
                                            isRTL: $('html').attr('dir') === 'rtl',
                                            onSelect: function(dateText, inst){
                                                var nextDay = $(this).datepicker('getDate'),
                                                    nextDayInput;
                                                if (nextDay) {
                                                    nextDay.setDate(nextDay.getDate() + 1);

                                                    var nextDate = (nextDay.getDate() < 10) ? '0' + nextDay.getDate()  : nextDay.getDate();
                                                    var nextMonth = (nextDay.getMonth() < 10) ? '0' + nextDay.getMonth() : nextDay.getMonth();
                                                    var nextYear = nextDay.getFullYear();

                                                    nextDayInput =  nextDate  + '/' +  nextMonth + '/' + nextYear;
                                                }
                                                arrival_datepicker.find('.ui-datepicker-inline').css('display', 'none');
                                                departure_datepicker.datepicker('option', 'minDate', nextDay);
                                                departure_input.val(nextDayInput);
                                                departure_datepicker.find('.ui-datepicker-inline').css('display', 'block');
                                                arrival_input.val(dateText);
                                            }
                                        });

                                        departure_datepicker.datepicker({
                                            dateFormat: dateFormat,
                                            firstDay: ($('html').attr('dir') === 'rtl') ? 0 : 1,
                                            minDate : tomorrow,
                                            isRTL: $('html').attr('dir') === 'rtl',
                                            onSelect: function(dateText, inst){
                                                departure_datepicker.find('.ui-datepicker-inline').css('display', 'none');
                                                departure_input.val(dateText);
                                            }
                                        });

                                        arrival_datepicker.find('.ui-datepicker-inline').css('display', 'none');
                                        departure_datepicker.find('.ui-datepicker-inline').css('display', 'none');

                                        arrival_input.on('click', function (){
                                            arrival_datepicker.find('.ui-datepicker-inline').css('display', 'block');
                                            departure_datepicker.find('.ui-datepicker-inline').css('display', 'none');
                                        });

                                        departure_input.on('click', function(){
                                            arrival_datepicker.find('.ui-datepicker-inline').css('display', 'none');
                                            departure_datepicker.find('.ui-datepicker-inline').css('display', 'block');
                                        });
                                }


                                }
                                if(cfg.bookable_type === 'form' || cfg.bookable_type === 'thirdparty'){
                                    var confirmation_btn = $('form').find('.form_overlay_close.btn_confirm');
                                    if(confirmation_btn.length > 0){
                                        confirmation_btn.on('click', function(){
                                            $(current.$smallBtn[0]).trigger('click');
                                        });
                                    }
                                }
                            }

                        }
                    }
                });
            }
            if (cfg.bookable_type === 'booking_engine') {
                var bookParams = {};
                if (typeof cfg.offer_tk !== 'undefined' && cfg.offer_tk !== '') {
                    bookParams.promoCode = cfg.offer_tk;
                }

                if (typeof cfg.offer_checkin !== 'undefined' && cfg.offer_checkin !== '') {
                    var parts = cfg.offer_checkin.split('/');
                    var the_date = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10)-1, parseInt(parts[0], 10));
                    window.console && console.log(the_date);
                    bookParams.checkInDate = the_date;
                    bookParams.checkOutDate = new Date(the_date.getTime() + 86400000 );
                }
                // TODO all the rest
                dedgeBookingInstance.getProvider().bookNow(bookParams);
            }
        });
    }
})(jQuery);